// extracted by mini-css-extract-plugin
module.exports = {"tableButton":"styles_tableButton__11WPz"};